import React, { Component } from 'react';
import { Button, Input } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import iconOpenUrl from '../ui/icons/iconOpenURL.svg';
import reactWindowSize from 'react-window-size';
import { getGoogleDriveFileId } from '../util/googleDriveUtils';
import VideoAkaireIcon from 'images/video_akaire.png';
import WWWAkaireIcon from 'images/icon-www.png';
import IconUploadImage from 'images/upload_image.png';
import IconUploadYoutube from 'images/upload_youtube.png';
import Cookies from 'js-cookie';
import imgConvertingPdfThumbnail from '/app/assets/images/thumbnail_temp_akaire_pdf.png';
import imgConvertingDefaultThumbnail from '/app/assets/images/default_loading_thumbnail.png';

class ListTempFile extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.videoRef = React.createRef();
    this.numberOfAnimations = Cookies.get('number_of_animations');
    if (Number(this.numberOfAnimations) !== this.props.animations.length) {
      window.location.reload();
    }
  }

  checkTypeAnimation = (animation) => {
    if(animation.is_video_embed) {
      return 'youtube'
    } else if (animation?.additional_info?.gdrive_image && !animation?.additional_info?.gdrive_pdf){
      return 'gdrive_image'
    } else if (animation.is_pdf) {
      return 'image'
    } else {
      var url = animation.file_object?.url?.split('.')
      if(!url || url[url.length - 1] == 'mp4') {
        return 'video'
      } else {
        return 'image'
      }
    }
  }

  animationButtonText = (animation) => {
    const info = animation?.additional_info
    if(info?.gdrive_file) {
      if(info.gdrive_image) {
        if(info.gdrive_pdf) {
          return 'データを保存して作業を開始する'
        } else {
          return 'ストリーミングして作業を開始する'
        }
      } else {
        return 'データを保存して作業を開始する'
      }
    }
    else if(animation.is_video_embed) {
      return 'ストリーミングして作業を開始する'
    }
    else {
      return 'データを保存して作業を開始する'
    }
  }

  getThumbnail = () => {
    if (this.videoRef.current) {
      const canvas = document.createElement('canvas');
      canvas.width = this.videoRef.current.videoWidth;
      canvas.height = this.videoRef.current.videoHeight;
      canvas.getContext('2d').drawImage(this.videoRef.current, 0, 0);

      const thumbnailUrl = canvas.toDataURL();
    }
  };

  getDuration = () => {
    if (this.videoRef.current) {
      return this.formatTime(this.videoRef.current.duration)
    }
  }

  formatTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.round(seconds % 60);

    const formattedTime = [hours, minutes, remainingSeconds]
      .map(unit => String(unit).padStart(2, '0')) // Thêm số 0 phía trước nếu cần
      .join(':');

    return formattedTime;
  }

  GoogleDriveFileId(url){
    return getGoogleDriveFileId(url);
  }

  assignAnimationId = (event) => {
    const animation_id = event.target.attributes.getNamedItem('data-animation-id').value;
    const animation_type = event.target.attributes.getNamedItem('data-type').value;
    const isCaptureUrl = event.target.attributes.getNamedItem('data-type-capture-url').value;
    const createFromProjectID = event.target.attributes.getNamedItem('data-from-project-id')?.value;
    const createFromProjectName = event.target.attributes.getNamedItem('data-from-project-name')?.value;
    const isShowTask = event.target.attributes.getNamedItem('data-is-show-task')?.value;
    const isProjectOwner = event.target.attributes.getNamedItem('data-is-project-owner')?.value;
    const fileName = event.target.attributes.getNamedItem('data-file-name')?.value;

    const createFromTaskID = event.target.attributes.getNamedItem('data-from-task-id')?.value || null;
    const createFromTaskName = event.target.attributes.getNamedItem('data-from-task-name')?.value || null;
    const createFromWorkID = event.target.attributes.getNamedItem('data-from-work-id')?.value || null;
    const createFromAkaireFileID = event.target.attributes.getNamedItem('data-from-akaire-file-id')?.value || null;
    const createFromPageID = event.target.attributes.getNamedItem('data-from-page-id')?.value || null;
    const withNewTask = event.target.attributes.getNamedItem('data-with-new-task')?.value || null;
    const selectProjectElement = $('#assignAkairePopup').find('.select-project-akaire');
    let select_default = selectProjectElement.attr('data-select-default')
    $('#assignAkairePopup').find('.select-project-akaire option').toArray().forEach(element => {
      $(element).text($(element).text().replace('【作成元】', ''))
    });
    $('#assignAkairePopup').find('.display-from-project-name').text(createFromProjectName)
    $('#assignAkairePopup').find('.display-from-task-name').text(createFromTaskName)
    $('#assignAkairePopup').find('.display-file-name').text(fileName)
    $('#assignAkairePopup').find('#saved-project-id').val(createFromProjectID)
    $('#assignAkairePopup').find('#saved-task-id').val(createFromTaskID)
    $('#assignAkairePopup').find('#is-show-task').val(isShowTask)
    $('#assignAkairePopup').find('#is-project-owner').val(isProjectOwner)
    $('#modalEditSavedProjectName').find('#edit-saved-project-id').val(createFromProjectID)
    $('#modalEditSavedProjectName').find('#projectEditName').val(createFromProjectName)
    $('#modalEditSavedTaskName').find('#edit-saved-task-id').val(createFromTaskID)
    $('#modalEditSavedTaskName').find('#taskEditName').val(createFromTaskName)

    if (!!createFromTaskID) {
      $('#assignAkairePopup').find('.setting-saved-task-wrapper').removeClass('d-none');
      $('#assignAkairePopup').find('.setting-saved-task-wrapper-dashed').removeClass('d-none');
      $('#assignAkairePopup').find('.task-setting-wrapper').addClass('d-none');
      $('#assignAkairePopup').find('.display-file-name').parent().addClass('ml-4');
    } else {
      $('#assignAkairePopup').find('.setting-saved-task-wrapper').addClass('d-none');
      $('#assignAkairePopup').find('.setting-saved-task-wrapper-dashed').addClass('d-none');
      $('#assignAkairePopup').find('.task-setting-wrapper').removeClass('d-none');
      $('#assignAkairePopup').find('.display-from-task-name').text('');
      $('#assignAkairePopup').find('#saved-task-id').val('');
      $('#modalEditSavedTaskName').find('#edit-saved-task-id').val('');
      $('#modalEditSavedTaskName').find('#taskEditName').val('');
      $('#assignAkairePopup').find('.display-file-name').parent().removeClass('ml-4');
    }

    selectProjectElement.attr('data-from-project-id', createFromProjectID || '')
    $('#assignAkairePopup').find(`.select-task-akaire`).attr('data-from-task-id', createFromTaskID || '')
    $('#assignAkairePopup').find(`.select-ticket-akaire`).attr('data-from-work-id', createFromWorkID || '')
    $('#assignAkairePopup').find(`.select-file-akaire`).attr('data-from-file-id', createFromAkaireFileID || '')
    $('#assignAkairePopup').find(`.select-page-akaire`).attr('data-from-page-id', createFromPageID || '')
    $('#assignAkairePopup').find('#animation_id').val(animation_id)
    $('#assignAkairePopup').find('#animation_type').val(animation_type)
    $('#assignAkairePopup').find('#animation_type').attr('is-capture-url', isCaptureUrl)
    selectProjectElement.val(select_default).trigger('change')
    $('.js-select-save-akaire').select2({
      width: '100%',
      "language": {
        "noResults": function(){
          return "検索に該当する結果はありません。";
        }
      }
    });
    $('.selection').attr("style", 'width: 100%');
    $('.select2-selection--single').attr("style", 'border: none; display: flex');
    const projectId = $('#assignAkairePopup').find('#saved-project-id').val();
    const taskId = $('#assignAkairePopup').find('#saved-task-id').val();
    const url = taskId ? Routes.get_list_participants_akaire_feature_akaires_path() : Routes.project_participants_akaire_feature_akaires_path()
    if(projectId) {
      Shared.callAjax(url, {project_id: projectId, animation_id: animation_id, saved_task_id: taskId}, 'script', 'GET').done(() => {})
      $('#assignAkairePopup').find('.number-user-invite-wrapper').addClass('d-none');
      $('#assignAkairePopup').find('.number-user-invite-wrapper-dashed').addClass('d-none');
    }
    $('.btn-submit-assign-akaire').addClass('d-none');
    $('.button-assign-member-wrapper').removeClass('d-none');
    ListTempFileJs.checkBlankProject(createFromProjectID, withNewTask)
  }

  transitPreviewAnimation = (animation_id, need_conversion) => {
    if(!need_conversion) {
      window.location.href = Routes.preview_animation_akaire_feature_akaires_path(animation_id);
    }
  }

  onError = (element) => {
    element.onerror = null;
    element.src = gon.assets.default_loading_thumbnail;
  }

  renderNormal() {
    const { animations } = this.props;
    return (
      <div className='d-flex my-3 col-12 container-list-temp-file inner_1600'>
        {(!animations || animations.length === 0) &&
          <div className='container-file-box-no-data'>現在、一時保管ファイルはありません。</div>
        }
        {animations && animations.map((animation, index) => (
          <div className='container-file-box col-4' key={`animation-${animation.id}`}>
            <div className='file-box' key={index} onClick={() => this.transitPreviewAnimation(animation.id, animation.need_conversion)}>
              <div className={`animation-display ${animation?.need_conversion ? '' : 'cursor-pointer'}`}>
                {!animation.need_conversion && this.checkTypeAnimation(animation) == 'video' &&
                  <div className="display-image-file">
                    <img src={animation.thumbnail} className="image-thumbnail" alt="Your Image" onError={({ currentTarget }) => this.onError(currentTarget)} />
                    <div className='akaire-name'>
                      <span className="text-ellipsis">
                        <img className="create-akaire-box-icon-upload filter-white-icon mr-2"src={VideoAkaireIcon} alt="アップロード" width="45" />
                        {animation.official_name}
                      </span>
                      <span>{animation.additional_info.duration || '00:00:00'}</span>
                    </div>
                  </div>}

                {!animation.need_conversion && this.checkTypeAnimation(animation) == 'image' &&
                  <div className="display-image-file">
                    <img src={!!animation.thumbnail ? animation.thumbnail : imgConvertingDefaultThumbnail} className="image-thumbnail" alt="Your Image" onError={({ currentTarget }) => this.onError(currentTarget)} />
                    <div className='akaire-image-name text-ellipsis'>
                      <img className="create-akaire-box-icon-upload filter-white-icon mr-2"src={ animation.official_name ? IconUploadImage : WWWAkaireIcon} alt="アップロード" width="35" />
                      {animation.official_name || animation.url}
                    </div>
                  </div>
                }

                {animation.need_conversion &&
                  <div className="display-image-file">
                    <img src={imgConvertingPdfThumbnail} className="image-thumbnail" alt="Your Image" onError={({ currentTarget }) => this.onError(currentTarget)} />
                    <div className='akaire-image-name text-ellipsis'>
                      <img className="create-akaire-box-icon-upload filter-white-icon mr-2"src={ this.checkTypeAnimation(animation) == 'video' ? VideoAkaireIcon : IconUploadImage} alt="アップロード" width="35" />
                      {animation.official_name || animation.url}
                    </div>
                  </div>
                }

                {(this.checkTypeAnimation(animation) == 'gdrive_image' && !animation.need_conversion) &&
                  <div className="display-image-file">
                    <img src={`https://drive.google.com/thumbnail?id=${this.GoogleDriveFileId(animation.url)}`} className="image-thumbnail" alt="Your Image" onError={({ currentTarget }) => this.onError(currentTarget)} />
                    <div className='akaire-image-name text-ellipsis'>
                      <img className="create-akaire-box-icon-upload filter-white-icon mr-2"src={ IconUploadImage } alt="アップロード" width="35" />
                      {animation.official_name || animation.url}
                    </div>
                  </div>
                }

                { this.checkTypeAnimation(animation) == 'youtube' &&
                  <div className="display-image-file">
                    <img src={animation.thumbnail} className="image-thumbnail" alt="Thumbnail Youtube" onError={({ currentTarget }) => this.onError(currentTarget)} />
                    <div className='akaire-name'>
                      <span className="text-ellipsis">
                        <img className="create-akaire-box-icon-upload filter-white-icon mr-2"src={IconUploadYoutube} alt="アップロード" width="45" />
                        {animation.additional_info.title || animation.url}
                      </span>
                      <span>{animation.additional_info.duration || '00:00:00'}</span>
                    </div>
                  </div>
                }
              </div>
              <div className={`akaire-information ${animation?.need_conversion ? '' : 'cursor-pointer'}`}>
                <span className="text-ellipsis">{animation.created_name}</span>
                {
                  !animation.need_conversion &&
                    <span className="text-ellipsis">{animation.volumn_file}｜残容量{animation.remain_data}</span>
                }
              </div>
              <div className={`akaire-expired ${animation?.need_conversion ? '' : 'cursor-pointer'} text-ellipsis`}>{animation.expired_time}</div>
            </div>
            <div className="text-center div-button-assign-file">
              <Button color="danger" className="button-assign-file" data-animation-id={animation.id} onClick={(event) => this.assignAnimationId(event)} data-type={this.checkTypeAnimation(animation)}
                data-type-capture-url={animation.use_account_login}
                data-from-project-id={animation.additional_info.from_project_id} data-from-project-name={animation.from_project_name} data-is-show-task={animation.is_show_task}
                data-is-project-owner={animation.is_project_owner}
                data-from-task-id={animation.additional_info.from_task_id} data-from-task-name={animation.from_task_name}
                data-from-work-id={animation.additional_info.from_work_id}
                data-with-new-task={animation.additional_info.with_new_task}
                data-toggle="modal"
                disabled={animation.need_conversion}
                data-file-name={animation.file_will_create}
                data-is-company-plan-akapon={animation.company_plan_akapon}
              >
                  { this.animationButtonText(animation) }
              </Button>
            </div>
          </div>
        ))}
      </div>
    )
  }

  render(){
    return this.renderNormal()
  }
}
export default reactWindowSize(ListTempFile);

export { ListTempFile };
